import { useState } from 'react'
import AspectRatio from '@mui/joy/AspectRatio'
import Card from '@mui/joy/Card'
import CardContent from '@mui/joy/CardContent'
import Typography from '@mui/joy/Typography'
import Box from '@mui/joy/Box'
import Chip from '@mui/joy/Chip'
import dayjs from 'dayjs'
import { DeleteButton } from './ui/DeleteButton'
import { EditButton } from './ui/EditButton'
import { DuplicateButton } from './ui/DuplicateButton'
import { PreviewButton } from './ui/PreviewButton'

const TYPE_MAP = {
    100: { color: 'warning', display: 'quote' },
    200: { color: 'success', display: 'blog' },
    300: { color: 'primary', display: 'listing' },
}

export const TemplateItem = ({
    template,
    onDelete,
    onEdit,
    onPreview,
    onClone,
    clonePending,
}) => {
    const [hovering, setHovering] = useState(false)

    let templateType = TYPE_MAP[template.type]
    return (
        <Card
            sx={{ width: 320 }}
            variant={hovering ? 'soft' : 'outlined'}
            onMouseEnter={() => setHovering(true)}
            onMouseLeave={() => setHovering(false)}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                    <Typography level="title-lg">{template.title}</Typography>
                    <Typography level="body-sm">
                        {dayjs(template.create_date).format('LLL')}
                    </Typography>
                </Box>
                <Box sx={{ alignSelf: 'flex-end' }}>
                    <Chip variant="soft" color={templateType.color}>
                        {templateType.display}
                    </Chip>
                </Box>
            </Box>
            <AspectRatio ratio="1/1">
                <img src={template.preview_image} />
            </AspectRatio>
            <CardContent
                orientation="horizontal"
                sx={{
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: 2,
                }}
            >
                {templateType.display === 'blog' && (
                    <PreviewButton onClick={() => onPreview(template.id)} />
                )}

                <DuplicateButton
                    onClick={() => onClone(template.id)}
                    isPending={clonePending}
                />
                <EditButton onClick={() => onEdit(template.id)} />
                <DeleteButton onClick={() => onDelete(template.id)} />
            </CardContent>
        </Card>
    )
}
